import { render, staticRenderFns } from "./_drawerTreat.vue?vue&type=template&id=1775c412&"
import script from "./_drawerTreat.vue?vue&type=script&lang=js&"
export * from "./_drawerTreat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports